import { gql } from 'apollo-angular';

export const SAVE_AGENT_TYPE = gql`
  mutation SaveAgentType($input: AgentTypeReqInput!) {
    saveAgentType(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        code
        deletedBy
        name
        uuid
      }
    }
  }
`;

export const DELETE_AGENT_TYPE = gql`
  mutation DeleteAgentType($uuid: String!) {
    deleteAgentType(uuid: $uuid) {
      code
      data
      dataList
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const GET_AGENT_TYPE = gql`
  query GetAgentType($uuid: String!) {
    getAgentType(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        code
        name
        uuid
      }
    }
  }
`;

export const GET_PAGINATED_AGENT_TYPES = gql`
  query GetPaginatedAgentTypes($pageable: PageableParamInput) {
    getPaginatedAgentTypes(pageable: $pageable) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        code
        name
        createdAt
        uuid
      }
      pageable {
        pageNumber
        pageSize
      }
    }
  }
`;
